import React from 'react'
import { useNavigate } from 'react-router-dom'
import './navbar.css'
import logo from './RMCHat.svg'
import { Link } from 'react-router-dom'
import auth from '../../lib/auth'

export default function Navbar() {
    let navigate = useNavigate()

    function logOut() {
        auth.logOut()
        navigate('/login')
    }

    return (
        <nav className='navbar'>
            <div className='container mx-auto flex items-center h-full gap-4'>
                <img
                    className='h-1/2'
                    id='rm-logo'
                    src={logo}
                    alt='Ringmaster: Master of Ceremonies'
                />
                <Link to='/' className='navbar-title'>
                    Ringmaster MC
                </Link>
                <div className='flex-grow' />
                {auth.isLoggedIn() && (
                    <Link className='navbar-button' to='/account'>
                        Account
                    </Link>
                )}
                {auth.isLoggedIn() && auth.checkRole('admin', 'lead') && (
                    <Link className='navbar-button' to='/admin'>
                        Site Admin
                    </Link>
                )}
                {auth.isLoggedIn() ? (
                    <span className='navbar-button orange cursor-pointer' onClick={logOut}>
                        Log Out
                    </span>
                ) : (
                    <Link className='navbar-button orange' to='/login'>
                        Log In
                    </Link>
                )}
            </div>
        </nav>
    )
}
